import Script from 'next/script';

interface ServiceSchemaProps {
  serviceType: string;
}
export function ServiceSchema({ serviceType }: ServiceSchemaProps) {
  return (
    <Script id='service-jsonld' type='application/ld+json'>
      {JSON.stringify({
        '@context': 'https://schema.org/',
        '@type': 'Service',
        serviceType: serviceType,
      })}
    </Script>
  );
}

export default ServiceSchema;
